import { HttpServiceBase } from './http-service-base';

export class ApplicationFormFieldService extends HttpServiceBase {
  constructor(...rest) {
    super(...rest);
  }

  getFormFields(applicationId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/v1/applicationFormFields?applicationId=${applicationId}`)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(this.transformResult(response)))
        .catch(e => reject(e));
    });
  }

  save(field) {
    return new Promise((resolve, reject) => {
      this.http.post('/v1/applicationFormFields', field)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  v2save(field) {
    return new Promise((resolve, reject) => {
      this.http.post('/v2/applicationFormFields', field)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  removeGroupItem(applicationId, groupName, groupIndex) {
    return new Promise((resolve, reject) => {
      this.http.delete(`/v1/applicationFormFields?applicationId=${applicationId}&groupName=${groupName}&groupIndex=${groupIndex}`)
        .then(data => JSON.parse(data.response))
        .then(response => resolve(response))
        .catch(e => reject(e));
    });
  }

  transformResult(response) {
    let formFields = {};
    for (let field of response) {
      if (field.groupName) {
        if (!formFields[field.groupName]) {
          formFields[field.groupName] = [];
        }

        let index = 0;
        let memberFound = false;

        for (let groupMember of formFields[field.groupName]) {
          if (groupMember[Object.keys(groupMember)[0]].groupIndex === field.groupIndex) {
            memberFound = true;
            break;
          }

          index++;
        }

        if (!memberFound) {
          index = formFields[field.groupName].length;
          formFields[field.groupName][index] = {};
        }

        formFields[field.groupName][index][field.name] = field;
        formFields[field.groupName][index].groupIndex = field.groupIndex;
        formFields[field.groupName][index].groupName = field.groupName;
        continue;
      }

      formFields[field.name] = field;
    }

    return formFields;
  }
}


